<template>
  <div class="wrp">
    <LeadInfo :leadSn="leadSn"></LeadInfo>
  </div>
</template>

<script>
import LeadInfo from "../components/Main/LeadInfo";
export default {
  components: {
    LeadInfo
  },
  data() {
    return {
      leadSn: ""
    };
  },
  created() {
    document.title = "名單資訊";
    this.leadSn = this.$route.query.ls;
  },
  methods: {}
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/MobileLeadInfoView.vue